import React, { useState } from 'react';
import { Button, Card } from 'react-bootstrap';

import SubtleBadge from 'components/common/SubtleBadge';

import { formatStatus } from 'utils/valueFormatters';
import { getInventoryBadgeColor } from 'constants/inventory';
import { TIME_OPTION } from 'constants/time';

const GRNLineTable = ({ grnData, onEdit, isCompleted }) => {
  const { grnId, items } = grnData;

  const [selectedItems, setSelectedItems] = useState([]);

  const handleSelectItem = itemId => {
    setSelectedItems(prev => {
      if (prev.includes(itemId)) {
        return prev.filter(id => id !== itemId);
      } else {
        return [...prev, itemId];
      }
    });
  };

  const handleSelectAll = () => {
    if (selectedItems.length === items.length) {
      setSelectedItems([]);
    } else {
      setSelectedItems(items.map(item => item.id));
    }
  };

  const handleEdit = () => {
    const selectedRows = items.filter(item => selectedItems.includes(item.id));

    onEdit(grnId, selectedRows);
  };

  return (
    <Card>
      <Card.Header>
        <div className="d-flex justify-content-between align-items-center">
          <h5 className="mb-0">GRN #{grnId}</h5>

          {!isCompleted && (
            <Button
              variant="falcon-default"
              size="sm"
              disabled={selectedItems.length === 0}
              onClick={handleEdit}
            >
              Edit
            </Button>
          )}
        </div>
      </Card.Header>

      <Card.Body className="p-0">
        <div className="table-responsive scrollbar">
          <table className="table table-sm table-striped fs-10 mb-0">
            <thead className="bg-200 text-nowrap align-middle text-center">
              <tr>
                {!isCompleted && (
                  <th>
                    <div className="form-check mb-0">
                      <input
                        type="checkbox"
                        className="form-check-input"
                        checked={
                          selectedItems.length === items.length &&
                          items.length > 0
                        }
                        onChange={handleSelectAll}
                      />
                    </div>
                  </th>
                )}
                <th className="text-start">Product SKU</th>
                <th className="text-start">Product Name</th>
                <th className="text-start">Vendor SKU</th>
                <th className="text-start">Vendor Name</th>
                <th className="text-start">Shelf Code</th>
                <th className="text-start">Shelf Name</th>
                <th className="text-center">Category</th>
                <th className="text-end">Quantity</th>
                <th className="text-end">Total Amount</th>
                <th className="text-start">Approved By</th>
                {/*<th className="text-start">Approved At</th>*/}
              </tr>
            </thead>
            <tbody className="align-middle white-space-nowrap text-center">
              {items.map(item => (
                <tr key={item.id}>
                  {!isCompleted && (
                    <td>
                      <div className="form-check mb-0">
                        <input
                          type="checkbox"
                          className="form-check-input"
                          checked={selectedItems.includes(item.id)}
                          onChange={() => handleSelectItem(item.id)}
                        />
                      </div>
                    </td>
                  )}
                  <td className="text-start">{item.product_sku}</td>
                  <td className="text-start">{item.product_name}</td>
                  <td className="text-start">{item.vendor_sku}</td>
                  <td className="text-start">{item.vendor_name}</td>
                  <td className="text-start">{item.shelf_code || '-'}</td>
                  <td className="text-start">{item.shelf_name || '-'}</td>
                  <td className="text-center">
                    <SubtleBadge
                      pill
                      bg={getInventoryBadgeColor(item?.inventory_type)}
                    >
                      {formatStatus(item?.inventory_type)}
                    </SubtleBadge>
                  </td>
                  <td className="text-end">{item.quantity}</td>
                  <td className="text-end">{item.total_amount}</td>
                  <td className="text-start">{item.approved_by}</td>
                  {/*<td className="text-start">*/}
                  {/*  {new Date(item.approved_at).toLocaleString(*/}
                  {/*    'en-IN',*/}
                  {/*    TIME_OPTION,*/}
                  {/*  )}*/}
                  {/*</td>*/}
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </Card.Body>
    </Card>
  );
};

export default GRNLineTable;
